import React, { Component } from 'react';
import { Box, Text } from "grommet";
import { StatusGoodSmall } from 'grommet-icons';
import styled from 'styled-components';
import { FORCED_GREY_FARMS, ALL_GREY_FARMS } from "../config";


const LegendIcon = (props) => props.hadBadSample ? (
  <span style={{
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '19px',
    height: '19px',
    border: '2px solid #c47d00',
    borderRadius: '50%',
    boxSizing: 'border-box',
  }}>
    <StatusGoodSmall size="10px" color={props.color} />
  </span>
) : <StatusGoodSmall size="15px" height="15px" color={props.color} />;

class StatusIconline extends Component {

  render() {
    const isSltDisabledFarm = FORCED_GREY_FARMS.includes((this.props.farmCode || '').toLowerCase());
    const isAllGreyFarm = ALL_GREY_FARMS.includes((this.props.farmCode || '').toLowerCase());

    const LegendText = styled(Text)`
      height: 15px;
      font-size: 60%;
      font-weight: normal;
      font-style: italic;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.14px;
      color: #767676;
      margin: ${props => props.margin}
    `

    const FootnoteText = styled(Text)`
      font-size: 11px;
      font-style: italic;
      line-height: 1.4;
      letter-spacing: 0.12px;
      color: #767676;
    `

    return (
      <Box width="1102px" style={{ marginTop: "19px" }}>
        <Box direction='row' justify='end'>
          <LegendText margin="0 5px 0 0">Data from the last 24 hours</LegendText>
          <LegendIcon color="#1aac60" />
          <LegendText margin="0 5px 0">Normal</LegendText>
          <LegendIcon color="#ffc002" />
          <LegendText margin="0 5px 0">Interrupted</LegendText>
          <LegendIcon color="#e5004c" />
          <LegendText margin="0 5px 0">Down</LegendText>
          <LegendIcon color="#bdbec0" />
          <LegendText margin={{right:"5px"}}>Maintenance</LegendText>
        </Box>
        <Box direction='row' justify='end' style={{ marginTop: "8px" }}>
          <LegendIcon color="#1aac60" hadBadSample />
          <LegendText margin="0 5px 0 0">Ring indicates an APM interruption or outage during that hour</LegendText>
        </Box>
        {isAllGreyFarm ?
          <Box direction='row' justify='end' style={{ marginTop: "8px" }}>
            <FootnoteText>
              Note: Monitoring for this farm is temporarily disabled and will show grey status until future updates.
            </FootnoteText>
          </Box>
          : isSltDisabledFarm ?
          <Box direction='row' justify='end' style={{ marginTop: "8px" }}>
            <FootnoteText>
              Note: The SMAX SLT Calculation monitor is not currently configured for this farm and is a work in progress.
            </FootnoteText>
          </Box>
          : null
        }
      </Box>
      
    )
  }
}

export default StatusIconline;
